import { useParams } from "react-router-dom";
import { useMemo } from "react";
export function useTypedParams(route) {
    const params = useParams();
    return useMemo(() => route.getTypedParams(params), [route, params]);
}
